import { render, staticRenderFns } from "./AgButton.vue?vue&type=template&id=4dfdcb15&scoped=true"
import script from "./AgButton.vue?vue&type=script&lang=js"
export * from "./AgButton.vue?vue&type=script&lang=js"
import style0 from "./AgButton.vue?vue&type=style&index=0&id=4dfdcb15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfdcb15",
  null
  
)

export default component.exports